function getTrustpilotData() {
  const trustCountEls = document.querySelectorAll(".trustCount");
  const trustStarEls = document.querySelectorAll(".trustStar");

  if (!trustCountEls.length && !trustStarEls.length) return;

  fetch(
    `https://widget.trustpilot.com/trustbox-data/56278e9abfbbba0bdcd568bc?businessUnitId=607d76edf0fef4000104260e&locale=${window.Shopify.locale}-${window.Shopify.country}`
  )
    .then((response) => response.json())
    .then((response) => {
      const totalReviews = response?.businessUnit?.numberOfReviews?.total;
      const trustScore = response?.businessUnit?.trustScore;

      if (totalReviews) {
        trustCountEls.forEach((el) => {
          el.innerHTML = totalReviews;
        });
      }

      if (trustScore) {
        trustStarEls.forEach((el) => {
          el.innerHTML = trustScore;
        });
      }
    })
    .catch(function () {});
}

document.addEventListener("DOMContentLoaded", function () {
  getTrustpilotData();

  const klaviyoLink = document.querySelector('a[href="#klaviyo"]');

  if (klaviyoLink) {
    klaviyoLink.addEventListener("click", function (event) {
      event.preventDefault();

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "TT7VsG"]);
    });
  }
});